export const PAYS_LIST_REQUESTING = 'pays/PAYS_LIST_REQUESTING';
export const PAYS_LIST_SUCCESS = 'pays/PAYS_LIST_SUCCESS';
export const PAYS_LIST_FAILED = 'pays/PAYS_LIST_FAILED';
